import { Box, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const Paginator = ({
    totalRecordCount,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    determinePaginationMessage,
    determinePaginationDisabledState,
    determineRowsPerPageOptions,
    currentPage
}) => {

    function determineCount(totalRecordCount, rowsPerPage) {
        const calculateCount = totalRecordCount / rowsPerPage;
        const hasRemainder = totalRecordCount % rowsPerPage;
        let count = calculateCount;
        if (hasRemainder) {
            count = Number(count.toString().split('.')[0]) + 1;
        }
        return count;
    }

    const paginationDisabled = determinePaginationDisabledState();
    const count = determineCount(totalRecordCount, rowsPerPage);

    const availableRowsPerPage = determineRowsPerPageOptions().map((rowsPerPageOption, i) => {
        return (
            <Button
                className='paginator-button-group'
                key={i}
                sx={{ backgroundColor: rowsPerPageOption === rowsPerPage ? '#EBEBEB' : '' }}
                value={rowsPerPageOption}
                onClick={(e) => handleChangeRowsPerPage(+e.target.value)}
            >
                {rowsPerPageOption}
            </Button>
        );
    });

    const paginationMessage = determinePaginationMessage();

    return (
        <Stack className='paginator' direction='row' alignItems='center' justifyContent='space-between'>
            <Box sx={{ mt: 3 }}>

                <ButtonGroup size='small' aria-label='small button group' >
                    {availableRowsPerPage}
                </ButtonGroup>
                <Typography fontSize={13} mt='0.5rem'>
                    {rowsPerPage + ' items per page'}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', mr: '1rem' }}>
                <Pagination page={currentPage + 1} onChange={(e, page) => { handleChangePage(page) }} count={+count} sx={{ mt: '20px' }} disabled={paginationDisabled} />
                <Typography fontSize={13} mt='0.5rem' ml='1rem'>
                    {paginationMessage}
                </Typography>
            </Box>
        </Stack>
    );
}
export default Paginator;